import React, { useState, useEffect, useRef } from "react";

const WarmupClean = () => {
  const [initialRecords, setInitialRecords] = useState(0);
  const [currentRecords, setCurrentRecords] = useState(0);
  const [message, setMessage] = useState("");
  const [started, setStarted] = useState(false);
  const [error, setError] = useState("");
  const intervalRef = useRef(null);

  const fetchWarmupCount = async () => {
    try {
      const res = await fetch("https://utilities.livauto.com/api/warmupcleancount");
      if (!res.ok) throw new Error("Failed to fetch count");
      const data = await res.json();
      return data[0]?.records || 0;
    } catch (err) {
      return null;
    }
  };

  const startWarmup = async () => {
    try {
      setError("");
      setStarted(true);

      // Get initial count
      const initial = await fetchWarmupCount();
      if (initial === null) {
        setStarted(false);
        return;
      }
      setInitialRecords(initial);
      setCurrentRecords(initial);

      // Start the warmup process
      const res = await fetch("https://utilities.livauto.com/api/warmupclean");
      if (!res.ok) throw new Error("Failed to start warmup");
      
      const data = await res.json();

      if (data.status === "already_running") {
        setMessage("Warmup is already running!");
      } else if (data.message) {
        setMessage(data.message);
      }

      // Start polling for updates
      intervalRef.current = setInterval(async () => {
        const current = await fetchWarmupCount();
        if (current !== null) {
          setCurrentRecords(current);
        }
      }, 5000); // Poll every 5 seconds

    } catch (err) {
      console.error("Error starting warmup:", err);
      setError(err.message || "Failed to start warmup");
      setStarted(false);
    }
  };

  const stopMonitoring = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setStarted(false);
    setMessage("Monitoring stopped");
  };

  useEffect(() => {
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, []);

  const newRecords = currentRecords - initialRecords;

  return (
    <div style={{ padding: "20px", fontFamily: "Arial", maxWidth: "600px" }}>
      <h2 style={{ marginBottom: "20px" }}>Warmup Clean</h2>

      {!started ? (
        <button
          onClick={startWarmup}
          style={{
            padding: "12px 24px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, transform 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = "#0056b3"}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = "#007bff"}
          onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
          onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
        >
          Start Warmup
        </button>
      ) : (
        <button
          onClick={stopMonitoring}
          style={{
            padding: "12px 24px",
            backgroundColor: "#dc3545",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            transition: "background-color 0.3s, transform 0.2s"
          }}
          onMouseEnter={e => e.currentTarget.style.backgroundColor = "#c82333"}
          onMouseLeave={e => e.currentTarget.style.backgroundColor = "#dc3545"}
          onMouseDown={e => e.currentTarget.style.transform = "scale(0.98)"}
          onMouseUp={e => e.currentTarget.style.transform = "scale(1)"}
        >
          Stop Monitoring
        </button>
      )}

      {error && (
        <div style={{
          marginTop: "15px",
          padding: "10px",
          backgroundColor: "#f8d7da",
          color: "#721c24",
          borderRadius: "4px",
          border: "1px solid #f5c6cb"
        }}>
          {error}
        </div>
      )}

      {message && (
        <p style={{ 
          marginTop: "15px", 
          color: "#28a745",
          fontWeight: "500"
        }}>
          {message}
        </p>
      )}

      {started && (
        <div style={{ marginTop: "20px" }}>
          <div style={{ 
            padding: "15px", 
            backgroundColor: "#f8f9fa", 
            borderRadius: "6px",
            border: "1px solid #dee2e6"
          }}>
            <p style={{ margin: "5px 0" }}>
              <strong>Initial Records:</strong> {initialRecords.toLocaleString()}
            </p>
            <p style={{ margin: "5px 0" }}>
              <strong>Current Records:</strong> {currentRecords.toLocaleString()}
            </p>
            <p style={{ 
              margin: "5px 0",
              color: newRecords > 0 ? "#28a745" : "#6c757d",
              fontSize: "18px",
              fontWeight: "bold"
            }}>
              <strong>New Records Processed:</strong> {newRecords.toLocaleString()}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default WarmupClean;